<template>
  <div
    :class="bem({'aspect-': props.aspectRatio})"
    :style="`--aspect-ratio: ${props.aspectRatio}`"
  >
    <div :class="bem('media-container')">
      <BaseVideo
        v-if="props.item.mediaType === 'video'"
        :video="props.item.video?.video"
        :preview-start-time="0"
        :will-loop="true"
        :bg-video="true"
        :full-width="true"
      />
      <DatoCmsImage
        v-if="props.item.mediaType === 'image'"
        :data="props.item.image.responsiveImage"
        object-fit="cover"
        :object-position="`${props.item.image.focalPoint.x * 100}% ${
          props.item.image.focalPoint.y * 100
        }%`"
        layout="fill"
      />
      <ImageReel
        v-if="props.item.mediaType === 'image_reel'"
        :images="props.item.reel"
        :speed="props.item.speed"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Image as DatoCmsImage } from 'vue-datocms'
interface MediaItemProps {
  item: {
    mediaType: string
    image?: any
    reel: any[]
    video?: any
    speed?: number
  }
  aspectRatio?:
    | '4 / 5'
    | '5 / 4'
    | '16 / 9'
    | '9 / 16'
    | '1 / 1'
    | '2 / 3'
    | 'auto'
}

const props = withDefaults(defineProps<MediaItemProps>(), {
  aspectRatio: '4 / 5',
})

const bem = useBEM('MediaItem')
</script>

<style lang="postcss">
.MediaItem {
  --border-radius: var(--media-item-border-radius, 8px);
  @apply aspect-[var(--aspect-ratio)];
  clip-path: inset(0 0 0 0 round var(--border-radius));

  &--aspect-auto {
    @apply h-full;
  }
}

.MediaItem__image-reel {
  @apply absolute inset-0;
}
</style>
